import { Component, EventEmitter, HostListener, Input, OnInit, Output } from "@angular/core";

import { faEllipsisH, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { TooltipDirective } from "../tooltip/tooltip.component";

export interface MenuItem {
  title: string
  icon?: IconDefinition
  action?: () => void
  route?: string
  queryParams?: {}
  item_id?: number
  danger?: boolean
  divider?: boolean
}
@Component({
  selector: 'dropdown-menu',
  imports: [FontAwesomeModule, FormsModule],
  templateUrl: './dropdown-menu.html'
})
export class DropdownMenuComponent implements OnInit {
  constructor(private router: Router) {
  }

  insideClick = false
  menuIsOpened = false
  @Input('menuItems') menuItems: MenuItem[] = []
  @Input('menu_id') menu_id: number = -1
  @Input('text') text: string = ""
  @Input('icon') icon: IconDefinition = faEllipsisH
  @Input('containerClass') containerClass: string = 'text-base flex px-[8px] py-[4px] items-center justify-center'
  @Input('clickedContainerClass') clickedContainerClass: string = 'text-lg  rounded-[8px] px-[8px] py-[4px] bg-[#B9C2CA] flex items-center justify-center'
  @Input('menuClass') menuClass: string = 'absolute border rounded border-[#8B96A2] bg-[#F6F7F8] shadow-sm z-10 flex flex-col overflow-hidden mt-1 w-auto text-nowrap'
  @Input('itemClass') itemClass: string = 'hover:bg-gray-200 px-3 py-2 text-left text-black'
  @Input('dangerItemClass') dangerItemClass: string = 'hover:bg-gray-200 px-3 py-2 text-left text-[#CC0033]'
  @Input('appearance') appearance: 'default' | 'outlined' = 'default'
  @Input() showOutline: boolean = true
  @Input() limit: number = 10
  @Output() limitChange = new EventEmitter<number>()
  @Output() getPage = new EventEmitter<Function>()
  @HostListener('click') onClick() {
    this.insideClick = true
  }
  @HostListener('document:click') onClickOut() {
    if (!this.insideClick)
      this.menuIsOpened = false
    this.insideClick = false
  }

  ngOnInit() {
    if (this.appearance === 'outlined') {
      const outline = this.showOutline ? ' outline outline-1 outline-offset-[-1px] outline-neutral-300' : ''
      this.containerClass = `flex items-center justify-center w-9 h-9 rounded-lg${outline} text-[#637381] hover:bg-[#F4F6F8] transition`
      this.clickedContainerClass = `flex items-center justify-center w-9 h-9 rounded-lg${outline} text-[#637381] bg-[#F4F6F8]`
      this.menuClass = 'absolute right-0 z-10 mt-1 py-1 flex flex-col min-w-[200px] w-max rounded-lg border border-[#D7D7D7] bg-white shadow-md overflow-hidden'
      this.itemClass = 'px-4 py-2 text-left text-sm text-black/90 hover:bg-[#F4F6F8] transition'
      this.dangerItemClass = 'px-4 py-2 text-left text-sm text-[#CC0033] hover:bg-[#FBEBEF] transition'
    }
  }

  actionClick(route?: string, queryParams?: {}, item_id?: number, action?: () => void) {
    if (this.limit != null && item_id != null) {
      this.limitChange.emit(item_id)
      this.getPage.emit(this.getPage)
      this.menuIsOpened = false
    }
    else if (route != null && queryParams != null)
      this.router.navigate([route], queryParams)
    else if (action != undefined)
      action()
  }

  protected readonly faEllipsisH = faEllipsisH;
}
